<template>
  <div>
    <div style="display: none" class="g-fixed-right-btn">
      <button class="back-top btn-item" v-show="backTopStatus" @click="backTop">
        <span class="fa fa-chevron-up"></span>
      </button>
      <!-- <a class="mnh" href="https://www.eeidm.com/view/newDetail.html?id=43719" target="_blank" v-if="mihType">
      <img
        src="./bg2.png"
      >
      </a> -->
      <!-- PageLocation: 1:侧边悬停  2:顶部悬停 3:底部悬停 4:弹出式  -->
      <div v-for="(item, index) in leftBannerList" :key="index + 'left'" :id="'Img' + index" @click="clickImg(item.ID)">
        <a
          :href="item.GoToURL ? item.GoToURL : 'javascript:;'"
          :target="item.GoToMode ? '_blank' : ''"
          v-if="(item.DisplayPage.includes(pageNum) > 0 || item.DisplayPage == 0) && item.PageLocation == 1"
        >
          <img :src="item.PictureURL" class="activityBg btn-item" :alt="item.Title" v-show="(!item.hidden && !bannerState) || item.ShowTime == 0" />
        </a>
      </div>
      <!-- <button class="technology btn-item" >
        <span>在线<br>咨询</span>
        <p  class="info">
          <ul>
            <li @click="openw('https://tb.53kf.com/code/client/e009a28fea6bf40b1cb25c1f0a3616961/1')">PCB+PCBA+BOM</li>
            <li @click="openw('https://tb.53kf.com/code/client/e009a28fea6bf40b1cb25c1f0a3616961/2')">CAD</li>
          </ul>
        </p>
      </button> -->
      <button class="technology btn-item" @click="openLink('http://wpa.qq.com/msgrd?v=3&uin=40227889&site=qq&menu=yes')">
        <span>技术<br />支持</span>
        <p class="info">
          <a href="http://wpa.qq.com/msgrd?v=3&uin=40227889&site=qq&menu=yes" target="_blank">QQ：40227889</a>
        </p>
      </button>
      <!-- <button class="tel btn-item">
        <span>电话</span>
        <p class="info">0752-5283248</p>
      </button> -->
      <button class="service btn-item" @click="openLink('http://wpa.qq.com/msgrd?v=3&uin=920952173&site=qq&menu=yes')">
        <span>客户<br />服务</span>
        <p class="info">
          <a href="http://wpa.qq.com/msgrd?v=3&uin=920952173&site=qq&menu=yes" target="_blank">QQ：920952173</a>
        </p>
      </button>
      <button class="hot-line btn-item">
        <span>热线</span>
        <p class="info">0752-5283248</p>
      </button>
    </div>

    <div class="fixed-right-sidebar" :style="`height:${bannerImgData.goUrl ? '540px' : '445px'}`">
      <div style="display: none" class="sidebar-item sidebar-activity">
        <div class="item">抽奖活动</div>
      </div>
      <a class="new_mnh" :href="bannerImgData.goUrl" :target="bannerImgData.targetPicture">
        <img :src="bannerImgData.pictureUrl" />
      </a>
      <div class="sidebar-main">
        <!-- <a class="new_mnh" :href="bannerImgData.goUrl" target="_blank">
          <img :src="bannerImgData.pictureUrl" />
        </a> -->
        <div @mouseover="sidebarTab(1)" @mouseout="sidebarTabOut" :class="['sidebar-item', 'sidebar-qq', fixedTab == 1 ? 'activeHidden' : '']">
          <div :class="['item-bj', fixedTab == 1 ? 'bj2' : '']">
            <div class="news">技术顾问</div>
          </div>
          <div :class="['item-box2', 'item-box', fixedTab == 1 ? 'activeH1' : '']">
            <div class="hover-item-i">
              <div class="item-b">
                <p>技术顾问QQ：</p>
                <h3>2881907330</h3>
                <a href="http://wpa.qq.com/msgrd?v=3&uin=2881907330&site=qq&menu=yes" target="_blank">联系我们</a>
              </div>
            </div>
            <!-- <div style="width:336px;">
          <div class="hover-item-q">
            <div class="item-l">
              <p>业务员1qq：</p>
              <h3>920952173</h3>
              <a href="http://wpa.qq.com/msgrd?v=3&uin=920952173&site=qq&menu=yes" target="_blank">联系我们</a>
            </div>
            <div class="item-r">
              <p>业务员2qq：</p>
              <h3>40227889</h3>
              <a href="http://wpa.qq.com/msgrd?v=3&uin=40227889&site=qq&menu=yes" target="_blank">联系我们</a>
            </div>
          </div>
        </div> -->
          </div>
        </div>
        <div @mouseover="sidebarTab(2)" @mouseout="sidebarTabOut" :class="['sidebar-item', 'sidebar-iphone', fixedTab == 2 ? 'activeHidden' : '']">
          <div :class="['item-bj', fixedTab == 2 ? 'bj3' : '']">
            <div class="news">服务热线</div>
            <div :class="['item-box3', 'item-box', fixedTab == 2 ? 'activeH1' : '']">
              <div class="hover-item-i">
                <div class="item-b">
                  <p>打电话联系我们：</p>
                  <h3>0752-5283248</h3>
                  <a href="javascript:void(0)" @click="copy" class="sidebar-copy" data-clipboard-text="0752-5283248">点击复制</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div @mouseover="sidebarTab(3)" @mouseout="sidebarTabOut" :class="['sidebar-item', 'sidebar-wechat', fixedTab == 3 ? 'activeHidden' : '']">
          <div :class="['item-bj', fixedTab == 3 ? 'bj1' : '']">
            <div class="news">最新资讯</div>
          </div>
          <div :class="['item-box1', 'item-box', fixedTab == 3 ? 'activeH1' : '']">
            <div class="hover-item">
              <img :src="require('./focusCode.png')" />
              <p>获取最新资讯</p>
            </div>
          </div>
        </div>
      </div>

      <div v-show="backTopStatus" class="sidebar-item sidebar-top">
        <div @click="backTop" class="fa fa-caret-up sidebar-up"></div>
      </div>
    </div>
    <div v-if="tips" class="sidebar-tips">复制成功</div>

    <!-- <div class="frame">
      <iframe src="https://tb.53kf.com/code/client/e61f2d50c7ddd96a5f4ac68050c6819c1/1" style="height:600px;width:800px;margin:0;border:0;padding:0;visibility: inherit;opacity:1;position:inherit;"></iframe>
    </div> -->

    <!-- <div
      v-for="(item, index) in leftBannerList"
      :key="index+'content'"
      :id="'Img'+index"
    >
      <div
        class="bottomImg"
        v-show="(!item.hidden && !bannerState) || item.ShowTime == 0"
      >
        <a
          :href="item.GoToURL?item.GoToURL:'javascript:;'"
          :target="item.GoToMode?'_blank':''"
          v-if="(item.DisplayPage.includes(pageNum) > 0 || item.DisplayPage==0)&& item.PageLocation == 3"
        >
          <div>
            <div
              class="close"
              @click="closePoster"
            ></div>
            <img
              :src="item.PictureURL"
              :alt="item.Title"
              @click="clickImg(item.ID)"
            >
          </div>
        </a>
      </div>
    </div> -->

    <!-- <div
      v-for="(item, index) in leftBannerList"
      :key="index"
      :ref="'content'+ index"
      :id="'content'+index"
    >
      <div
        class="contentImg"
        v-show="(!item.hidden && !bannerState) || item.ShowTime == 0"
      >
        <a
          :ref="'content'+ index"
          :href="item.GoToURL?item.GoToURL:'javascript:;'"
          :target="item.GoToMode?'_blank':''"
          v-if="(item.DisplayPage.includes(pageNum) > 0 || item.DisplayPage==0)&& item.PageLocation == 4"
        >
          <div
            class="close"
            @click="closePoster"
          ></div>
          <img
            :src="item.PictureURL"
            :alt="item.Title"
            v-show="!item.hidden"
            @click="clickImg(item.ID)"
          >
        </a>
      </div>
    </div> -->
  </div>
</template>
<script>
import Clipboard from 'clipboard'
import { thirdParty, ERR_OK, ERR_LOGINAGAIN, storageVTime } from 'api/config'
import { getBanner, IMGClick, cmsBannerNew } from 'api/banner'
import * as util from 'assets/js/util'
import { setTimeout, clearTimeout } from 'timers'
import { mapMutations, mapGetters, mapActions } from 'vuex'
import axios from 'api/axios'
export default {
  data() {
    return {
      backTopStatus: false,
      scrollTop: 0,
      mihType: false,
      leftBannerList: [],
      pageNum: 0,
      fixedTab: -1,
      tips: false,
      bannerImgData: '',
      channelId: 2
    }
  },
  created() {
    let url = window.location.pathname
    if (url == '/cad' || url == '/cadIndex') {
      this.pageNum = 4
    } else if (url.includes('/goods') || url.includes('/bom')) {
      this.pageNum = 6
    } else if (url == '/index/inquire' || url == '/index/PCB' || url == '/index/PCBA' || url.includes('/index/submitAudit') || url.includes('/result')) {
      this.pageNum = 2
    }
    this.leftBanners()
    this.getCMSBanner()
  },
  computed: {
    ...mapGetters(['bannerState'])
  },
  mounted() {
    window.addEventListener('scroll', this.scrollToTop)
    // console.log(window.screen.height * window.devicePixelRatio,'12122112')
    let heigthF = window.screen.height * window.devicePixelRatio // 分辨率高
    // 最小尺寸 適配
    if (heigthF <= '768') {
      document.getElementsByClassName('fixed-right-sidebar')[0].style.cssText = 'top:158px;'
    } else if (heigthF <= '900') {
      document.getElementsByClassName('fixed-right-sidebar')[0].style.cssText = 'top:230px;'
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    // 复制
    copy() {
      var clipboard = new Clipboard('.sidebar-copy')
      clipboard.on('success', (e) => {
        // alert("复制成功");
        this.tips = true
        setTimeout(() => {
          this.tips = false
        }, 3000)
        clipboard.destroy()
      })
      clipboard.on('error', (e) => {
        // 不支持复制
        // Message({
        //   message: "该浏览器不支持自动复制",
        //   type: "warning",
        // });
        // 释放内存
        clipboard.destroy()
      })
    },
    // 侧边栏
    sidebarTab(index) {
      // console.log(index)
      this.fixedTab = index
    },
    // 鼠标离开
    sidebarTabOut() {
      this.fixedTab = -1
    },
    mesgTip(message, other = {}) {
      let opt = Object.assign(
        {},
        {
          showClose: true,
          message: message || '出错了！',
          type: 'error'
        },
        other
      )
      this.$message(opt)
    },
    toFormData(o) {
      const formData = new FormData()
      for (let [key, value] of Object.entries(o)) {
        if (value !== undefined) {
          if (value == null) {
            value = ''
          }
          formData.append(key, value)
          continue
        }
      }
      return formData
    },
    getCMSBanner() {
      const param = this.toFormData({
        pageNumber: 1,
        pageSize: 20,
        categoryId: 156,
        status: 1,
        channelId: 2,
        port: 'PC'
      })
      this.$axios.post(`https://cms.eeidm.com/picture/noAuth/list`, param).then((res) => {
        console.log(res, 'res')
        if (res.data.rows.length > 0) {
          this.bannerImgData = res.data.rows[0]
        }
      })
      // let params = {
      //   CMD: 3,
      //   categoryId: 9,
      //   channelId: this.channelId
      // };
      // return cmsBannerNew(params)
      //   .then(res => {
      //     console.log(res.rows, "cms");
      //     if (this.channelId == 2 && res.rows.length > 0) {
      //       this.bannerImgData = res.rows[0];
      //     }
      //     // this.bannerImg
      //     if (res.status != ERR_OK) {
      //       return Promise.reject(res);
      //     }
      //     // if (res) {
      //     console.log(res, "cms");
      //     // }
      //   })
      //   .catch(erro => {
      //     if (!erro.isCancel) {
      //       var opt = {};
      //       if (erro.code && erro.code == ERR_LOGINAGAIN) {
      //         opt = {
      //           onClose() {
      //             util.common.toLogin();
      //           }
      //         };
      //       }
      //       // this.mesgTip(erro.msg, opt);
      //     }
      //   });
      // .finally(() => {});
    },
    leftBanners() {
      let param = {
        protNum: 0, // 0:pcd端 1： 移动端
        pageName: 0 // 0:全局 1: 首页 2：idm 3：方案设计 4：高速pcb设计 5：ees 6：bom 7：登录 8：注册
      }
      return getBanner(param)
        .then((res) => {
          if (res.code != ERR_OK) {
            return Promise.reject(res)
          }
          if (res.result) {
            console.log(res, 'old')
            // if (!this.bannerState) {
            this.leftBannerList = res.result
            this.setTime(res.result)
            // }
          }
        })
        .catch((erro) => {
          if (!erro.isCancel) {
            var opt = {}
            if (erro.code && erro.code == ERR_LOGINAGAIN) {
              opt = {
                onClose() {
                  util.common.toLogin()
                }
              }
            }
            this.mesgTip(erro.message, opt)
          }
        })
        .finally(() => {})
    },
    setTime(list) {
      list = Array.isArray(list) ? list : []
      for (let item of list) {
        if (item.ShowTime > 0) {
          let show = item.ShowTime * 1000
          item.ID = setTimeout(() => {
            this.$set(item, 'hidden', true)
            this.SetBannerState(true)
          }, show)
        }
      }
    },
    closePoster() {
      this.SetBannerState(true)
    },
    clickImg(id) {
      let param = {
        ID: id._id
      }
      return IMGClick(param)
        .then((res) => {
          if (res.code != ERR_OK) {
            return Promise.reject(res)
          }
          if (res.result) {
          }
        })
        .catch((erro) => {
          if (!erro.isCancel) {
            var opt = {}
            if (erro.code && erro.code == ERR_LOGINAGAIN) {
              opt = {
                onClose() {
                  util.common.toLogin()
                }
              }
            }
            this.mesgTip(erro.message, opt)
          }
        })
        .finally(() => {})
    },
    ...mapMutations({
      SetBannerState: 'SET_BANNERSTATE'
    }),
    // nowTime() {
    //   var now = new Date();
    //   var nowYear = now.getFullYear();
    //   var nowMonth = now.getMonth() + 1;
    //   var nowDay = now.getDate();
    //   var nowHour = now.getHours();
    //   if (nowDay > 4) {
    //     this.mihType = false;
    //   }
    // },
    scrollToTop() {
      const that = this
      // window.pageXOffset ||
      that.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      // console.log(that.scrollTop,'chufa?')
      if (that.scrollTop > 500) {
        that.backTopStatus = true
      } else {
        that.backTopStatus = false
      }
    },
    backTop() {
      const that = this
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16)
    }
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import '~assets/scss/compile';
@import './fixed';
</style>



// WEBPACK FOOTER //
// src/components/common/fixed/fixed.vue